import { config } from '../../config/config';
import { isNumeric } from '../../helpers';

const useUserSlippage = () => {
    const localSlippage = localStorage.getItem('slippage');

    return localSlippage && isNumeric(localSlippage)
        ? localSlippage
        : config.slippage.default.toString();
};

export default useUserSlippage;
